/**
 * PdvDesktopConnectionService
 *
 * Verifica se o dispositivo possui conexão com a internet.
 * Usado para decidir entre emissão normal (tpEmis=1) e contingência (tpEmis=9).
 */

const PdvDesktopConnectionService = {
  /**
   * Retorna true se o dispositivo estiver com internet (navigator.onLine).
   *
   * @returns {Promise<boolean>}
   */
  async verificarConexaoBackend() {
    const online = navigator.onLine;
    console.log('[PDV DESKTOP] verificarConexaoBackend → navigator.onLine:', online);
    return online;
  },
};

export default PdvDesktopConnectionService;
